import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">韩漫免费阅读</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">汇集最优质的韩漫资源，提供免费无遮阅读体验，让每一位漫迷都能畅享韩国漫画的魅力。</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">关于我们</Link></li>
              <li><Link to="/category/shuang-nanzhu" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">下拉双男主</Link></li>
              <li><Link to="/category/mianfei-wuzhe" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">免费无遮</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line text-base"></i>
                <span>contact@manhuafree.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-customer-service-line text-base"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">© 2026 韩漫免费阅读 - 本站所有漫画资源仅供学习交流使用</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}